import { createSelector } from '@ngrx/store';
import { selectResultsState } from '../results.selectors';
import {
  Card,
  RealEstateObject,
  ResultsState,
  SearchResultsState,
} from '@immosky/types';
import { ListCardComponent } from '@immosky/shared';
import { SearchResultPageFactory } from './search-result-page-factory';

const pageFactory = new SearchResultPageFactory();

export const selectSearchResultsState = createSelector(
  selectResultsState,
  (resultsState: ResultsState) => resultsState.searchResults
);

export const selectRealEstateObjects = createSelector(
  selectSearchResultsState,
  (state: SearchResultsState) => state.realEstateObjects
);

export const selectSearchResultCount = createSelector(
  selectRealEstateObjects,
  (results: RealEstateObject[]) => results.length
);

export const selectPlaceholderCards = createSelector(
  selectSearchResultsState,
  (resultsState: SearchResultsState) => resultsState.placeholderCards
);

export const selectPages = createSelector(
  selectRealEstateObjects,
  selectPlaceholderCards,
  (realEstateObjects, placeholderCards) => {
    const realEstateCards = realEstateObjects.map(
      (object: RealEstateObject) => {
        return new Card(ListCardComponent, object, object.id);
      }
    );

    pageFactory.setState({
      searchResultCards: realEstateCards,
      placeholderCards: placeholderCards,
    });

    return pageFactory.createPages();
  }
);

export const selectPageIndex = createSelector(
  selectSearchResultsState,
  (state: SearchResultsState) => state.pageIndex
);

export const selectInitialPageIndex = createSelector(
  selectSearchResultsState,
  (state: SearchResultsState) => state.initialPageIndex
);

export const selectIsOnLastResultPage = createSelector(
  selectPages,
  selectPageIndex,
  (pages, pageIndex) => pageIndex === pages.length - 1
);
